
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/[partnersPages]",
      function () {
        return require("private-next-pages/partners/[partnersPages].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/[partnersPages]"])
      });
    }
  